import {
  Component,
  ComponentFactoryResolver,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Type,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {FormFieldInstance} from '../model/FormFieldInstance';
import {AbstractDynamicFormFieldDirective} from './abstract-dynamic-form-field.directive';
import {FormFieldType} from '../model/FormFieldType';
import {DffTextareaComponent} from './dff-textarea.component';
import {DffInputComponent} from './dff-input.component';
import {DffSelectComponent} from './dff-select.component';
import {DffCheckboxComponent} from './dff-checkbox.component';
import {DffDateAndTimeComponent} from './dff-date-and-time.component';
import {DffPeriodComponent} from './dff-period.component';
import {DffRadioButtonGroupComponent} from './dff-radio-button-group.component';
import {DffCheckboxGroupComponent} from './dff-checkbox-group.component';
import {DffFileUploadComponent} from './dff-file-upload.component';
import {DffBusinessObjectComponent} from './dff-business-object.component';
import {DffTabGroupComponent} from './dff-tab-group.component';

@Component({
  selector: 'app-dff-common',
  template: `
    <ng-template #content>
    </ng-template>

    <ng-container *ngIf="component && this.fieldRef.touched">
      <div *ngFor="let error of this.fieldRef.errors" style="color:red; font-size: 11px">
        {{error | translate}}
      </div>
    </ng-container>
  `,
})
export class DffCommonComponent implements OnInit {

  @Input() field: FormFieldInstance;
  @Output() initialized = new EventEmitter<AbstractDynamicFormFieldDirective>();
  @ViewChild('content', {read: ViewContainerRef, static: true}) vc: ViewContainerRef;

  fieldRef: AbstractDynamicFormFieldDirective;
  component: Type<AbstractDynamicFormFieldDirective>;

  constructor(private readonly cfr: ComponentFactoryResolver) { }

  ngOnInit() {
    this.component = this.resolve(this.field.type);
    if (!this.component) { return; }
    const componentFactory = this.cfr.resolveComponentFactory(this.component);
    const componentRef = this.vc.createComponent(componentFactory);
    componentRef.instance.field = this.field;
    this.fieldRef = componentRef.instance;
    this.initialized.emit(this.fieldRef);
  }

  resolve(formFieldType: FormFieldType): Type<AbstractDynamicFormFieldDirective> {
    if (isInput(formFieldType)) {
      return DffInputComponent;
    }

    if (isDate(formFieldType)) {
      return DffDateAndTimeComponent;
    }

    if (formFieldType === FormFieldType.TEXTAREA) {
      return DffTextareaComponent;
    }

    if (formFieldType === FormFieldType.DROPDOWN_SINGLE) {
      return DffSelectComponent;
    }

    if (formFieldType === FormFieldType.CHECKBOX) {
      return DffCheckboxComponent;
    }

    if (formFieldType === FormFieldType.PERIOD) {
      return DffPeriodComponent;
    }

    if (formFieldType === FormFieldType.RADIO_BUTTON_GROUP) {
      return DffRadioButtonGroupComponent;
    }

    if (formFieldType === FormFieldType.CHECKBOX_GROUP) {
      return DffCheckboxGroupComponent;
    }

    if (formFieldType === FormFieldType.FILE_UPLOAD) {
      return DffFileUploadComponent;
    }

    if (formFieldType === FormFieldType.BUSINESS_OBJECT) {
      return DffBusinessObjectComponent;
    }

    if (formFieldType === FormFieldType.TAB_GROUP) {
      return DffTabGroupComponent;
    }

    return undefined;
  }

}

const isDate: (type: FormFieldType) => boolean = (type) => {
  return type === FormFieldType.DATE
    || type === FormFieldType.FULL_DATE
    || type === FormFieldType.YEAR
    || type === FormFieldType.YEAR_AND_MONTH
    || type === FormFieldType.TIME;
};

const isInput: (type: FormFieldType) => boolean = (type) => {
  return type === FormFieldType.INPUT_PHONE
    || type === FormFieldType.INPUT_EMAIL
    || type === FormFieldType.INPUT_TEXT
    || type === FormFieldType.INPUT_NUMBER;
};
